import { useMemo } from 'react';

import { Percent, Vault } from 'lucide-react';
import { useJobContext } from 'pages/Job/context';

import { ICON_PROPS } from './constants';

const NoOptions: React.FunctionComponent = function () {
  const { jobCompanyInfo } = useJobContext();
  const hideOpenBanking = useMemo(() => {
    if (!jobCompanyInfo) return false;
    return Boolean(jobCompanyInfo.hide_openbanking);
  }, [jobCompanyInfo]);
  return (
    <div className="flex flex-col gap-y-3 p-4 md:p-6 border-2 rounded-xl transition-all group shadow-lg bg-neutral-000 border-neutral-300">
      <h2 className="text-16-24-em text-neutral-800">
        There are no available payment options for this job
      </h2>
      <h2 className="text-12-18 md:text-14-22 text-neutral-700">
        Unfortunately, there are no payment options available on this quote at
        this time. This is because:
      </h2>
      <div className="flex flex-row gap-x-2">
        <Percent {...ICON_PROPS} />
        <span className="text-12-18 text-neutral-700 md:mt-px">
          There are no available finance options for this quote, due to either
          the price, deposit or work type not being servicable
        </span>
      </div>
      {!hideOpenBanking && (
        <>
          <div className="flex flex-row gap-x-2">
            <Vault {...ICON_PROPS} />
            <span className="text-12-18 text-neutral-700 md:mt-px">
              Open Banking being unavailable as the price of the job (minus any
              deposit) exceeds £10,000 or is currently unavailable
            </span>
          </div>
        </>
      )}
      <span className="text-12-18 md:text-14-22 text-neutral-700">
        If you would like more help, you can reach out to Ideal4Finance either
        via the <span className="font-semibold">&quot;Book A Call&quot;</span>{' '}
        button to schedule a call, the{' '}
        <span className="font-semibold">&quot;Need Help&quot;</span> button to
        talk to live chat or call us on{' '}
        <a
          href="tel:+443308187502"
          className="underline text-purple-500 font-semibold"
        >
          +44 330 818 7502
        </a>
      </span>
    </div>
  );
};

export default NoOptions;
